import React from 'react'
import LoadingRightFlyoutContent from 'src/components/LoadingRightFlyoutContent/LoadingRightFlyoutContent'
import RightFlyout, { RightFlyoutBodyWidths } from 'src/components/RightFlyout/RightFlyout'

const PeopleDetailContent = React.lazy(() => import('./PeopleDetailContent'))

export interface PeopleDetailFlyoutProps {
  invitedFlyout?: boolean
}

const PeopleDetailFlyout: React.FC<PeopleDetailFlyoutProps> = (
  props,
): React.ReactElement => {
  const [showContent, setShowContent] = React.useState(false)

  React.useEffect(() => {
    const id = requestAnimationFrame(() => setTimeout(() => {
      setShowContent(true)
    }, 500))
    return () => cancelAnimationFrame(id)
  }, [])

  return (
    <RightFlyout width={RightFlyoutBodyWidths.Action}>
      <React.Suspense fallback={<LoadingRightFlyoutContent />}>
        {showContent && <PeopleDetailContent />}
        {!showContent && <LoadingRightFlyoutContent />}
      </React.Suspense>
    </RightFlyout>
  )
}

export default PeopleDetailFlyout